<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
      <form
      @submit="saveData"
      method="post"
      >
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $tc('employees.label', 1) }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $tc('employees.label', 1) }}</h3>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.name')" type="text" placeholder="Ej: Juan Perez" v-model="employee.name" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.address')" type="text" placeholder="Ej: 27 de Febrero" v-model="employee.address" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.phone')" type="text" placeholder="Ej: 809-111-1111" v-model="employee.phone" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.personal_id')" type="text" placeholder="Ej: 000-0000000-9" v-model="employee.personal_id" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('fields.payment_type')" 
                :value.sync="employee.payment_type"
                :plain="true"
                :options="payment_types"
                :placeholder="$t('fields.payment_type_placeholder')"
                required
              >
              </CSelect>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.salary')" type="text" prepend="$" placeholder="Ex: 1000" v-model="employee.salary" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
              :label="$t('fields.is_active')"
              :value.sync="employee.status"
              :plain="true"
              :options="statuses"
              :placeholder="$t('fields.status_placeholder')"
              required
              >
              </CSelect>
            </div>
            <div class="col-6">
               <CTextarea :label="$t('fields.comment')" :placeholder="$t('fields.comment_placeholder')" v-model="employee.comment"></CTextarea>
            </div>
          </div>
          <CButton color="success" type="submit">
            <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
            <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormEmployee',
  mixins: [formMixin, localeMixin],
  addIcon: cilPlus,
  updateIcon: cilSync,
  backIcon: cilArrowLeft,
  data() {
    return {
        employee: {
          name: '',
          address: '',
          phone: '',
          personal_id: '',
          payment_type: '',
          salary: '',
          comment: '',
          status: ''
        },
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ],
        payment_types: [
          {
            label: i18n.t('fields.payment_days'),
            value: 'days'
          },
          {
            label: i18n.t('fields.payment_weekly'),
            value: 'weekly'
          }
        ]
    }
  },
  mounted() {
    if (this.isEditing) {
        this.getEmployee();
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    goBack() {
      this.$router.push({ name: 'Employees' });
    },
    showAlert(type) {
      let title = '';
      let body = '';
      let status = '';

      switch(type) {
        case 'add':
          title = i18n.t('employees.modal.created_label');
          body = i18n.t('employees.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('employees.modal.updated_label');
          body = i18n.t('employees.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = 'There was an error processing you request';
          status = 'error';
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        this.goBack();
      });
    },
    saveData(e) {
        e.preventDefault();
        const data = this.employee;
        this.$emit("saved", data);
        let url = `/api/employees`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.message = 'Successfully updated employee.';
                        this.showAlert('edit');
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error');
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.message = 'Successfully created employee.';
                        this.showAlert('add');
                    }
                    console.log(response);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error');
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    getEmployee() {
        const id = this.$route.params.id;
        axios.get('/api/employees/'+ id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.employee = response.data;
            this.employee.status_class = this.employee.status ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.showAlertError(); 
        });
    }
  }
}

</script>
